import MuiDrawer from '@mui/material/Drawer';
import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

const StyledDesktopDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }: any) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: 240,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

interface DesktopDrawerProps extends PropsWithChildren<{ open: boolean }> {
}

const DesktopDrawer = ({ open, children }: DesktopDrawerProps) => (
    <StyledDesktopDrawer variant="permanent" open={open}>
        {children}
    </StyledDesktopDrawer>
);

export default DesktopDrawer;
